import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";
import { DocumentFilter } from "../models/DocumentFilter";
import { DocumentFiltersOptions } from "../models/DocumentFiltersOptions";

@Injectable({
  providedIn: "root",
})
export class DocumentFiltersService {
  private baseUrl_V2 = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/admin/documentFilters`;

  constructor(private http: HttpClient) {}

  getDocumentFilterOptions(): Observable<DocumentFiltersOptions> {
    return this.http.get<DocumentFiltersOptions>(`${this.baseUrl_V2}/params`);
  }

  getDocumentFilters(famCode: string, userRole: string): Observable<DocumentFilter[]> {
    return this.http.get<DocumentFilter[]>(
      `${this.baseUrl_V2}?famCode=${famCode}&roleName=${userRole}`,
    );
  }

  addDocumentFilter(documentFilter: DocumentFilter) {
    return this.http.post(`${this.baseUrl_V2}`, documentFilter);
  }

  deleteDocumentFilter(documentFilter: DocumentFilter) {
    return this.http.post(`${this.baseUrl_V2}/delete`, documentFilter);
  }
}
